{
  "cycle.entite.annonces_prix": "Annonces de prix des paliers",
  "cycle.entite.avis_consommation": "Avis de consommation",
  "cycle.entite.changements_abonnement": "Changements d’abonnement",
  "cycle.entite.coordonnees_facturation": "Coordonnées de facturation",
  "cycle.entite.credits_organisation": "Crédits de l’organisation",
  "cycle.entite.demandes_exception": "Demandes d’exception de facturation",
  "cycle.entite.demandes_exception_evenements": "Événements des demandes d’exception",
  "cycle.entite.devis_revisions": "Révisions des devis",
  "cycle.entite.exceptions_facturation": "Exceptions de facturation accordées",
  "cycle.entite.factures": "Factures et avoirs",
  "cycle.entite.factures_lignes": "Lignes de facture",
  "cycle.entite.imputations_credit": "Imputations de crédit",
  "cycle.entite.liens_paiement": "Liens de paiement des factures",
  "cycle.entite.litiges_paiement": "Litiges de paiement",
  "cycle.entite.migrations_abonnes": "Migrations des abonnés d’un palier",
  "cycle.entite.moyens_paiement": "Moyens de paiement",
  "cycle.entite.paliers_prix": "Prix des versions de palier",
  "cycle.entite.paliers_versions": "Versions des paliers",
  "cycle.entite.plan_catalog": "Paliers sur mesure de l’organisation",
  "cycle.entite.reglements_recus": "Règlements reçus",
  "v9.paliers.abonnees.vide": "Aucune organisation abonnée à ce palier.",
  "v9.paliers.annuler": "Annuler",
  "v9.paliers.brouillon.enregistre": "Brouillon du palier enregistré.",
  "v9.paliers.brouillon_v": "brouillon v{{version}}",
  "v9.paliers.carte_iban_prestataire": "Les cartes et IBAN sont saisis chez le prestataire de paiement : DoIt ne les reçoit jamais.",
  "v9.paliers.champ.code": "Code du palier",
  "v9.paliers.champ.code.aide": "Lettres minuscules, chiffres et tirets, 20 caractères au plus ; le préfixe « sm- » est réservé.",
  "v9.paliers.champ.devise": "Devise",
  "v9.paliers.champ.effet_le": "Date d'effet",
  "v9.paliers.champ.mode": "Mode",
  "v9.paliers.champ.motif": "Motif",
  "v9.paliers.champ.nom": "Nom du palier",
  "v9.paliers.champ.periodicite": "Périodicité",
  "v9.paliers.champ.preavis": "Préavis (jours)",
  "v9.paliers.champ.prix": "Prix",
  "v9.paliers.champ.prix_par_devise": "Prix par devise",
  "v9.paliers.champ.quotas": "Quotas",
  "v9.paliers.champ.version_cible": "Version cible",
  "v9.paliers.code.CONTEXTE_INCOMPLET": "Aucune organisation n'est associée à votre session.",
  "v9.paliers.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire à cette action.",
  "v9.paliers.code.PALIER_CODE_DEJA_UTILISE": "Ce code est déjà porté par un palier, retiré compris.",
  "v9.paliers.code.PALIER_DEJA_RETIRE": "Ce palier est déjà retiré de l'offre.",
  "v9.paliers.code.PALIER_NOM_DEJA_UTILISE": "Ce nom est déjà porté par un autre palier.",
  "v9.paliers.code.PALIER_PREAVIS_INSUFFISANT": "Hausse de prix : le préavis est inférieur au minimum des paramètres de facturation.",
  "v9.paliers.code.PALIER_VERSION_NON_BROUILLON": "Cette version est publiée : créez une nouvelle version pour la modifier.",
  "v9.paliers.code.PALIER_VERSION_NON_PUBLIEE": "La version cible n'est pas publiée.",
  "v9.paliers.code.PRESTATAIRE_INDISPONIBLE": "Le prestataire de paiement n'est pas joignable : rien n'a été modifié.",
  "v9.paliers.code.PROPRIETAIRE_SEUL": "Réservé au propriétaire de l'organisation.",
  "v9.paliers.code.RESOURCE_UNAVAILABLE": "Palier ou version introuvable.",
  "v9.paliers.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v9.paliers.code.VALIDATION_ERROR": "Saisie refusée : vérifiez le code, les quotas, les devises et les montants.",
  "v9.paliers.code.VERSION_CONFLICT": "Ce palier a été modifié entre-temps : rechargez la page avant de recommencer.",
  "v9.paliers.colonne.abonnes": "Abonnés",
  "v9.paliers.colonne.actions": "Actions",
  "v9.paliers.colonne.palier": "Palier",
  "v9.paliers.colonne.statut": "Statut",
  "v9.paliers.colonne.version": "Version en vigueur",
  "v9.paliers.comparer.actuel": "Votre palier actuel",
  "v9.paliers.comparer.changer_periodicite": "Changer de périodicité",
  "v9.paliers.comparer.choisir": "Choisir ce palier",
  "v9.paliers.comparer.depasse": "Ce qui dépasse le palier cible",
  "v9.paliers.comparer.devis": "Demander un devis",
  "v9.paliers.comparer.effet.actuel": "Palier actuel.",
  "v9.paliers.comparer.effet.descente": "Descente : quotas réduits.",
  "v9.paliers.comparer.effet.descente_bloquee": "Descente bloquée : votre usage dépasse les quotas de ce palier.",
  "v9.paliers.comparer.effet.montee": "Montée : quotas augmentés.",
  "v9.paliers.comparer.raison.changement_a_venir": "Le changement de palier en libre-service arrive avec l’écran de changement d’abonnement.",
  "v9.paliers.comparer.raison.devis_a_venir": "La demande de devis arrive avec l’écran des demandes d’exception.",
  "v9.paliers.comparer.raison.grise_palier_actuel_meme_periodicite": "C’est déjà votre palier, à cette périodicité.",
  "v9.paliers.comparer.raison.grise_usage_au_dessus_des_quotas_cibles": "Votre usage dépasse les quotas de ce palier : réduisez-le avant de descendre.",
  "v9.paliers.comparer.raison.sur_devis": "Palier sur devis : demandez un devis.",
  "v9.paliers.comparer.retour": "Retour à l'abonnement",
  "v9.paliers.comparer.sans_prix_periodicite": "Aucun prix pour cette périodicité.",
  "v9.paliers.comparer.sur_devis": "Sur devis",
  "v9.paliers.comparer.vide": "Aucun palier publié pour le moment.",
  "v9.paliers.depart.brouillon": "Modification du brouillon (version {{version}}).",
  "v9.paliers.depart.publiee": "Nouvelle version à partir de la version publiée {{version}}.",
  "v9.paliers.ecran.dialogue-palier": "Créer ou modifier un palier (brouillon)",
  "v9.paliers.ecran.organisation-paliers-comparer": "Comparer les paliers et en choisir un",
  "v9.paliers.ecran.plateforme-palier-fiche": "Palier — quotas, prix et abonnés",
  "v9.paliers.ecran.plateforme-paliers": "Catalogue des paliers",
  "v9.paliers.effet_abonnements.au_prochain_renouvellement": "Les abonnés gardent leur version jusqu’au prochain renouvellement.",
  "v9.paliers.effet_abonnements.aucun_abonne": "Aucun abonné : la publication n’affecte aucune organisation.",
  "v9.paliers.effet_le": "effet le {{date}}",
  "v9.paliers.en_cours": "En cours…",
  "v9.paliers.enregistrer_brouillon": "Enregistrer le brouillon",
  "v9.paliers.erreur.enregistrer": "Le brouillon n'a pas été enregistré.",
  "v9.paliers.erreur.migrer": "La migration n'a pas été programmée.",
  "v9.paliers.erreur.publier": "La version n'a pas été publiée.",
  "v9.paliers.erreur.retirer": "Le palier n'a pas été retiré.",
  "v9.paliers.etat.chargement": "Chargement : {{quoi}}…",
  "v9.paliers.etat.erreur": "Impossible de lire : {{quoi}}.",
  "v9.paliers.etat.refus": "Accès refusé.",
  "v9.paliers.etat.vide": "Rien à afficher.",
  "v9.paliers.invalide.code": "Code invalide : lettres minuscules, chiffres et tirets, 2 à 20 caractères, sans « sm- ».",
  "v9.paliers.invalide.doublon": "Un seul prix par devise et périodicité.",
  "v9.paliers.invalide.motif": "Le motif du retrait est obligatoire.",
  "v9.paliers.invalide.nom": "Le nom est obligatoire.",
  "v9.paliers.invalide.prix": "Chaque prix est un montant positif ou nul.",
  "v9.paliers.invalide.quota": "Chaque quota est un entier positif ou nul.",
  "v9.paliers.invalide.version_cible": "Choisissez une version publiée comme cible.",
  "v9.paliers.liste.vide": "Aucun palier au catalogue.",
  "v9.paliers.migrer": "Migrer les abonnés",
  "v9.paliers.migrer.bloquee": "{{organisation}} : bloquée par son usage ({{quotas}})",
  "v9.paliers.migrer.bloquees": "Organisations bloquées par leur usage",
  "v9.paliers.migrer.programmees": "{{n}} organisation(s) programmée(s).",
  "v9.paliers.migrer.selection": "Organisations (aucune cochée : toutes)",
  "v9.paliers.migrer.titre": "Migrer les abonnés vers une version",
  "v9.paliers.mode.creation": "Création d’un palier",
  "v9.paliers.mode.nouvelle_version": "Nouvelle version du palier {{nom}}",
  "v9.paliers.mode_migration.au_renouvellement": "Au renouvellement",
  "v9.paliers.mode_migration.immediat_au_prorata": "Immédiat, au prorata",
  "v9.paliers.modifier_brouillon": "Modifier le brouillon",
  "v9.paliers.nouveau": "Nouveau palier",
  "v9.paliers.nouvelle_version": "Nouvelle version",
  "v9.paliers.periodicite.annuelle": "annuelle",
  "v9.paliers.periodicite.mensuelle": "mensuelle",
  "v9.paliers.preavis.aide": "Une hausse de prix exige le préavis minimum des paramètres de facturation.",
  "v9.paliers.prix.ajouter": "Ajouter le prix",
  "v9.paliers.prix.aucun": "Aucun prix.",
  "v9.paliers.prix.retirer": "Retirer le prix {{devise}} {{periodicite}}",
  "v9.paliers.publier": "Publier la version {{version}}",
  "v9.paliers.publier.succes": "Version publiée ; {{annonces}} annonce(s) de prix envoyée(s).",
  "v9.paliers.publier.titre": "Publier la version {{version}}",
  "v9.paliers.quoi.catalogue": "le catalogue des paliers",
  "v9.paliers.quoi.palier": "le palier",
  "v9.paliers.quoi.paliers_publies": "les paliers publiés",
  "v9.paliers.quota.ai_calls_per_day": "Appels IA par jour",
  "v9.paliers.quota.document_size_mb": "Taille d’un document (Mo)",
  "v9.paliers.quota.documents_count": "Documents",
  "v9.paliers.quota.requests_per_minute": "Requêtes par minute",
  "v9.paliers.quota.tokens_per_day": "Jetons par jour",
  "v9.paliers.reessayer": "Réessayer",
  "v9.paliers.retirer": "Retirer de l'offre",
  "v9.paliers.retirer.aide": "Les abonnés conservent le palier jusqu’à leur renouvellement.",
  "v9.paliers.retirer.deja": "Retiré de l'offre le {{date}}.",
  "v9.paliers.retirer.titre": "Retirer le palier de l'offre",
  "v9.paliers.retour": "Retour au catalogue",
  "v9.paliers.section.abonnees": "Organisations abonnées",
  "v9.paliers.section.prix": "Prix",
  "v9.paliers.section.quotas": "Quotas",
  "v9.paliers.section.versions": "Versions",
  "v9.paliers.statut.brouillon": "Brouillon",
  "v9.paliers.statut.publie": "Publié",
  "v9.paliers.statut.retire": "Retiré de l'offre",
  "v9.paliers.statut_version.brouillon": "brouillon",
  "v9.paliers.statut_version.publiee": "publiée",
  "v9.paliers.statut_version.remplacee": "remplacée",
  "v9.paliers.synchronisation.a_synchroniser": "à synchroniser",
  "v9.paliers.synchronisation.echec": "échec de synchronisation",
  "v9.paliers.synchronisation.synchronise": "synchronisé chez le prestataire",
  "v9.paliers.version_historique": "limites historiques",
  "v9.paliers.version_n": "version {{version}}",
  "v9.paliers.versions.vide": "Aucune version.",
  "v9.paliers.voir": "Voir",
  "v9.paliers.voir_palier": "Voir le palier {{nom}}",
  "v9.paliers.comparer.aucun_depassement": "Aucun quota au-delà de ce palier.",
  "v9.paliers.depart.creation": "Nouveau palier : il commence à la version 1, en brouillon."
}
